import { autoinject, bindable, computedFrom } from 'aurelia-framework';
import { json } from 'aurelia-fetch-client';
import { NodeModel } from "../../models/node-model";
import { RowValidationErrorModel } from '../../models/row-validation-error-model';
import { ApiService } from '../../utils/api-service';
import { IStructureParser } from "./structure-parsers/structure-parser";
import { ResourcedNotificationService, NotificationType } from "../notifications/notification-service";
import { remove } from "lodash";

@autoinject
export class OrganizationStructureImport {
	@bindable importUrl: string;
	@bindable refreshStructure: () => void;
	@bindable parser: IStructureParser<NodeModel[]>;

	showPreview: boolean = false;
	submitting: boolean = false;
	errors: RowValidationErrorModel[] = [];
	rawData: string;

	constructor(private notificationService: ResourcedNotificationService, private http: ApiService) {}

	@computedFrom("rawData")
	get structureData(): NodeModel[] {
		const flatdata = this.parser.parseRawInput(this.rawData);
		return this.createHierarchy(flatdata);
	}

	createHierarchy(flatNodes: NodeModel[]): NodeModel[] {
		const hierarchy = [];

		const rootNodes = flatNodes.filter((root: NodeModel) => root.level === 0);

		rootNodes.forEach(root => {
			this.createChildNodes(root, flatNodes);
			hierarchy.push(root);
		});

		return hierarchy;
	}

	private createChildNodes(node: NodeModel, nodeCollection: NodeModel[]): void {
		const children = remove(nodeCollection, (children: NodeModel) => {
			return children.parent === node;
		});

		if (children && children.length > 0) {
			children.forEach(o => this.createChildNodes(o, nodeCollection));
		}

		children.forEach(o => node.children.push(o));
	}

	toggleShowPreview(): void {
		this.showPreview = !this.showPreview;
	}

	submit(): void {
		this.submitting = true;
		this.errors = null;

		var importVM = this.parser.parseRawInputToImportVM(this.rawData);
		
		this.http.fetch(this.importUrl, {
			method: "post",
			body: json(importVM)
		})
		.then(this.handleResponse.bind(this))
		.catch(error => {
			this.submitting = false;
			this.notificationService.push("Label_ErrorInSubmit", NotificationType.Error, error);
			console.log("Unhandled error in request", error);
		});
	}

	handleResponse(response): void {
		if (response.status !== 200) {
			response.json()
				.then((errors) => {
					this.notificationService.push("Label_ErrorInSubmit", NotificationType.Error);
					this.errors = RowValidationErrorModel.createFromValidationErrors(errors);
				});
		} else {
			this.refreshStructure();
			this.notificationService.push("ViewMessage_SaveSucceeded", NotificationType.Success);
			this.rawData = "";
		}
		this.showPreview = false;
		this.submitting = false;
	}
}
